import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import InviteDecisionPanel from './InviteDecisionPanel';

const Page = styled.div`margin:1.5rem 1rem 3rem;position:relative;@media(max-width:640px){margin:0 0 2rem;}`;
const Hero = styled.div`position:relative;background:#fff;box-shadow:0 25px 50px -12px rgba(0,0,0,.18);`;
const HeroInner = styled.div`max-width:78rem;margin:0 auto;padding:3.25rem 2.5rem 2.75rem;@media(max-width:600px){padding:2.25rem 1.5rem;}`;
const BigHeadline = styled.h1`margin:0;color:#47ABDB;font-weight:800;text-transform:uppercase;letter-spacing:.02em;line-height:1.04;font-size:clamp(2rem,4.6vw,3.4rem);`;
const SubHeadline = styled.p`margin:.85rem 0 0;color:#5B5B5B;font-weight:700;font-size:clamp(1rem,1.9vw,1.35rem);`;
const Grey = styled.div`background:#d0e6ef;`;
const GreyInner = styled.div`max-width:46rem;margin:0 auto;padding:2rem 2.5rem;@media(max-width:640px){padding:1.5rem 1rem;}`;
const Card = styled.div`background:#fff;padding:1.75rem;box-shadow:0 8px 24px rgba(15,23,42,.08);@media(max-width:640px){padding:1.25rem;}`;

// Full-page version of answering an invitation - no longer where opening the
// invite email lands (see SpeakerInvitationLanding.js's nextStep, which now
// goes straight to /profile, where the same decision happens inline right on
// the engagement's own card - see InviteDecisionPanel.js, which both places
// share). This page stays reachable for the Speaker Hub's own "Respond to
// invitation" link, and for any already-sent email whose button still points
// at /speaker/invite/respond - a dead link is worse than a page that still
// works, even if it's no longer the primary way here.
const SpeakerInviteRespond = () => {
  const intl = useIntl();
  const t = (id, defaultMessage, values) => intl.formatMessage({ id, defaultMessage }, values);
  const navigate = useNavigate();
  const eventId = new URLSearchParams(useLocation().search).get('event');
  const [eventName, setEventName] = useState(null);

  if (!eventId) { navigate('/speaker/dashboard', { replace: true }); return null; }

  return (
    <Page>
      <Hero>
        <HeroInner>
          <BigHeadline>{t('speaker.respond.headline', 'Your invitation')}</BigHeadline>
          {eventName && <SubHeadline>{eventName}</SubHeadline>}
        </HeroInner>
      </Hero>
      <Grey>
        <GreyInner>
          <Card>
            <InviteDecisionPanel eventId={eventId}
              onEventName={(name, nameEN) => setEventName(name && (intl.locale || '').startsWith('de') ? name : (nameEN || name))} />
          </Card>
        </GreyInner>
      </Grey>
    </Page>
  );
};

export default SpeakerInviteRespond;
